import { supabase } from '../supabaseClient';

/* Accès aux données « affaire_vues ». Chaque fonction renvoie la requête Supabase telle quelle
   (à attendre par l'appelant) : aucune logique métier ici. */

export function fetchDealViews() {
  return supabase.from('affaire_vues').select('*').order('created_at', { ascending: true });
}

export function insertDealView(dealsFilter, dealsView, nom, session) {
  return supabase.from('affaire_vues').insert({
    user_id: session.user.id,
    nom: nom.trim(),
    config: { view: dealsView, filter: dealsFilter },
    partagee: false,
  });
}

export function deleteDealView(id) {
  return supabase.from('affaire_vues').delete().eq('id', id);
}

export function updateDealView(v) {
  return supabase.from('affaire_vues').update({ partagee: !v.partagee }).eq('id', v.id);
}
